import { canUserAccessPrivateData } from '@/services/AuthService';

export default {
  methods: {
    // The "Annuaire" term is used in internal to know if a mean of telecom is public or not.
    // The "Defaut" term is also used in internal to know if this is the default mean of telecom of the person.
    // We don't want those values to be displayed in public mode.
    removeAnnuaireAndDefautValuesFromStringIfNotConnected(string) {
      if (canUserAccessPrivateData()) {
        return string;
      }

      return string.replace(/Annuaire/g, '').replace(/Defaut/g, '');
    },
  },
};
